<template>
  <div class="login-container">
    <el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left">
      <div class="title-container">
        <h3 class="title">智眼企业后台管理系统</h3>
        <!-- <lang-select class="set-language"></lang-select> -->
      </div>
      <el-form-item prop="username">
        <span class="svg-container svg-container_login">
          <!-- <svg-icon icon-class="user" /> -->
        </span>
        <el-input name="username" type="text" v-model="loginForm.username" autoComplete="on" placeholder="用户名" />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <!-- <svg-icon icon-class="password" /> -->
        </span>
        <el-input name="password" :type="passwordType" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="on" placeholder="密码" />
<!--        <span class="show-pwd" @click="showPwd">-->
<!--          &lt;!&ndash; <svg-icon icon-class="eye" /> &ndash;&gt;-->
<!--        </span>-->
      </el-form-item>
      <div class="btn-wrapper">
        <el-button type="primary" class="btn"
                   :loading="loading" @click.native.prevent="handleLogin">登陆
      </el-button>
<!--      <el-button type="primary" class="btn btn-right"-->
<!--                 :loading="loading" @click.native.prevent="handleFaceLogin">登陆到人脸管理-->
<!--      </el-button>-->
      </div>

      <!--<div class="tips">-->
      <!--<span>内测阶段</span>-->
      <!--&lt;!&ndash; <span>{{$t('login.password')}} : {{$t('login.any')}}</span> &ndash;&gt;-->
      <!--</div>-->
      <!-- <div class="tips">
        <span style="margin-right:18px;">{{$t('login.username')}} : editor</span>
        <span>{{$t('login.password')}} : {{$t('login.any')}}</span>Y
      </div> -->
    </el-form>

    <!-- <el-dialog title="第三方" :visible.sync="showDialog" append-to-body>
      第三方
      <br/>
      <br/>
      <br/>
      <social-sign />
    </el-dialog> -->

  </div>
</template>

<script>
// import { isvalidUsername } from '@/utils/validate'
// import LangSelect from '@/components/LangSelect'
// import SocialSign from './socialsignin'
import { apiLogin, apiFaceLogin } from '@/api'
export default {
  // components: { LangSelect, SocialSign },
  components: {},
  name: 'Login',
  data () {
    const validateUsername = (rule, value, callback) => {
      // if (!isvalidUsername(value)) {
      //   callback(new Error('Please enter the correct user name'))
      // } else {
      //   callback()
      // }
      callback()
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('The password can not be less than 1 digits'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', validator: validateUsername }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ]
      },
      passwordType: 'password',
      loading: false,
      showDialog: false
    }
  },
  methods: {
    async handleFaceLogin () {
      try {

      } catch (e) {
        this.$message.error('登陆失败' + e.message)
      }
    },
    showPwd () {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
    },
    handleLogin () {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          // const loginUrl = "http://121.41.92.64:7705/login/";
          try {
            const res = await apiLogin(this.loginForm.username, this.loginForm.password)
            // const res1 = await apiFaceLogin(this.loginForm.username, this.loginForm.password)
            // this.$store.commit('setFaceCanteenList', res1.canteen_info_list)
            this.loading = false
            const { api_key, eatery_id } = res
            const phoneNum = 0
            this.$store.dispatch('setUserinfo', { api_key, eatery_id, username: this.loginForm.username, phoneNum })
            this.$router.push({ path: '/main' })
            this.$message.success('登陆成功')
          } catch (e) {
            this.loading = false
            console.log(e)
            this.$message.error('登录失败, ' + e.message)
          }
        } else {
          return false
        }
      })
    },
    afterQRScan () {
    }
  },
  created () {
    // window.addEventListener('hashchange', this.afterQRScan)
  },
  destroyed () {
    // window.removeEventListener('hashchange', this.afterQRScan)
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #eee;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
    &::first-line {
      color: $light_gray;
    }
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;
      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }
  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 80%;
    max-width: 500px;
    margin: 120px auto;
    .btn {
      width:100%;
      margin-bottom:30px;
      display: inline-block;
      &.btn-right {
        float: right;
    }
    }
  }
  .tips {
    font-size: 14px;
    color: #fff;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .title-container {
    position: relative;
    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
    .set-language {
      color: #fff;
      position: absolute;
      top: 5px;
      right: 0px;
    }
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .thirdparty-button {
    position: absolute;
    right: 0px;
    bottom: 5px;
  }
}
</style>
